<template>
  <div
    v-if="items"
    :class="color && `${color}-container`"
    class="text-on-surface-variant mt-2 mb-3 flex flex-row flex-wrap items-center justify-center gap-2.5 leading-0!"
  >
    <span v-if="!splitByPerspective" class="text-body-medium inline-flex items-center gap-1">
      <BaseIcon size="18" :class="color && 'text-primary'">network_wifi_2_bar</BaseIcon>
      <span class="text-label-large">
        <template v-if="items.mainValue === 'others'">{{ $t('perspectives.others') }}</template>
        <template v-else>{{ labelForKey(items.mainValue) }}</template>
      </span>
    </span>
    <div
      class="overflow-hidden transition-all duration-300"
      :class="!active ? 'max-w-0' : 'max-w-full'"
    >
      <PerspectiveLegend :perspectives="items.perspectives" :all-perspectives="allPerspectives" />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { SELF_PERSPECTIVE_KEY, type Perspective } from '@/core/models/perspective'
  import { resolvePerspectiveLabel } from '@/core/models/perspective-label'
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import PerspectiveLegend from '../../question-list/PerspectiveLegend.vue'

  interface Props {
    perspectives: ReadonlySet<string>
    allPerspectives?: ReadonlyArray<Perspective>
    active: boolean
    color?: string
    splitByPerspective: boolean
  }

  const { perspectives, allPerspectives = [], splitByPerspective } = defineProps<Props>()
  const { t } = useI18n()

  const labelForKey = (key: string) =>
    resolvePerspectiveLabel(key, allPerspectives, {
      selfLabel: t('perspectives.self'),
    })

  const items = computed(() => {
    const hasSelf = perspectives.has(SELF_PERSPECTIVE_KEY)
    const others = [...perspectives].filter((key) => key !== SELF_PERSPECTIVE_KEY)
    const hasOthers = others.length > 0

    if (hasSelf && hasOthers) {
      return {
        mainValue: 'others',
        perspectives: [SELF_PERSPECTIVE_KEY, ...others],
      }
    }
    if (hasSelf && !hasOthers) {
      return { mainValue: SELF_PERSPECTIVE_KEY, perspectives: [] as string[] }
    }
    if (!hasSelf && hasOthers && others.length == 1) {
      return { mainValue: others[0], perspectives: [] as string[] }
    }
    if (!hasSelf && hasOthers) {
      return { mainValue: 'others', perspectives: others as string[] }
    }

    return null
  })
</script>
